import type { ReimbursementStepId } from './types';

export const REIMBURSEMENT_BASE_PATH = '/reimbursement/$offerRequestLeadUuid' as const;

export const REIMBURSEMENT_STEP_PATHS = {
    terms: '/reimbursement/$offerRequestLeadUuid/terms',
    reason: '/reimbursement/$offerRequestLeadUuid/reason',
    details: '/reimbursement/$offerRequestLeadUuid/details',
} as const satisfies Record<ReimbursementStepId, string>;

export type ReimbursementStepPath = (typeof REIMBURSEMENT_STEP_PATHS)[ReimbursementStepId];

// Which list the lead was opened from, so leaving the flow returns to the detail page the partner came
// from rather than guessing one.
export const REIMBURSEMENT_ORIGINS = ['new-requests', 'open-requests'] as const;
export type ReimbursementOrigin = (typeof REIMBURSEMENT_ORIGINS)[number];

export const DEFAULT_REIMBURSEMENT_ORIGIN: ReimbursementOrigin = 'open-requests';

export function toReimbursementOrigin(value: unknown): ReimbursementOrigin {
    return (REIMBURSEMENT_ORIGINS as ReadonlyArray<unknown>).includes(value)
        ? (value as ReimbursementOrigin)
        : DEFAULT_REIMBURSEMENT_ORIGIN;
}

export const OFFER_REQUEST_DETAIL_PATHS = {
    'new-requests': '/new-requests/$offerRequestLeadUuid',
    'open-requests': '/open-requests/$offerRequestLeadUuid',
} as const satisfies Record<ReimbursementOrigin, string>;
